exports = module.exports = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._2FZ-N9DcS6_5SIODkailYu{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;width:100%;height:100%}._2hTNUMo7HZYx7nknwq1DZn{position:relative;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1}", ""]);
// Exports
exports.locals = {
	"mainContent": "_2FZ-N9DcS6_5SIODkailYu",
	"surfaceContainer": "_2hTNUMo7HZYx7nknwq1DZn"
};